var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"module-loading-overlay"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"overlay_loading"},[_c('lottie-vue-player',{attrs:{"autoplay":"","loop":"","backgroundColor":"transparent","mode":"normal","src":`${_vm.VUE_APP_PUBLIC_PATH}lotties/layout/loading.json`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }